<template>
	<v-col cols="12" v-if="permisoVista('mantenimiento-historial','r')">
		<v-row class="text-center">
			<v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-autocomplete
					v-model="filtros.tipo"
					:items="tipos"
					item-value="idTipo"
					item-text="nombre"
					label="Tipo"
					hide-details
					clearable
					@change="mantenimientos_update_page_action(1)"
				></v-autocomplete>
			</v-col>
			<v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-autocomplete
					multiple
					small-chips
					v-model="filtros.codigosNombres"
					:items="computedCodNom"
					:item-value="codNombres"
					:item-text="lblcodNom"
					label="Código o Nombre"
					hide-details
					clearable
					@change="mantenimientos_update_page_action(1)"
				></v-autocomplete>
			</v-col>
			<v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-autocomplete
					v-model="filtros.categoria"
					:items="categorias"
					item-value="idMaquinaCategoria"
					item-text="categoria"
					label="Categoría"
					hide-details
					clearable
					@change="changeCategoria"
				></v-autocomplete>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-autocomplete
					v-model="maquinasFiltradas"
					:items="maquinasFiltradas"
					item-value="idMaquina"
					:item-text="marcaModelo"
					label="Máquina"
					hide-details
					clearable
					@change="changeMaquina"
				>
				</v-autocomplete>
			</v-col>
			<v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-autocomplete
					v-model="filtros.instancia"
					:items="instanciasFiltradas()"
					item-value="idMaquinaIns"
					item-text="nombre"
					label="Máquina Instancia"
					clearable
					hide-details
					@change="mantenimientos_update_page_action(1)"
				>
				</v-autocomplete>
			</v-col>
			<v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-autocomplete
					v-model="filtros.responsable"
					:items="personas"
					:item-text="nombrePersona"
					item-value="idPersona"
					label="Responsable"
					clearable
					hide-details
					@change="mantenimientos_update_page_action(1)"
				>
				</v-autocomplete>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-autocomplete
					v-model="filtros.mecanicos"
					:items="personas"
					:item-text="nombrePersona"
					item-value="idPersona"
					label="Realizado Por"
					clearable
					hide-details
					multiple
					chips
					deletable-chips
					@change="mantenimientos_update_page_action(1)"
				>
				</v-autocomplete>
			</v-col>
			<v-col cols="4" md="4" sm="4" class="align-self-end">
				<VueCtkDateTimePicker
					v-model="filtros.inicio"
					label="Desde"
					format="YYYY-MM-DD HH:mm"
					formatted="YYYY-MM-DD HH:mm"
					noHeader
					overlay
					buttonNowTranslation="Ahora"
					@input="mantenimientos_update_page_action(1)"
				/>
			</v-col>
			<v-col cols="4" md="4" sm="4" class="align-self-end">
				<VueCtkDateTimePicker
					v-model="filtros.fin"
					:min-date="filtros.inicio"
					label="Hasta"
					format="YYYY-MM-DD HH:mm"
					formatted="YYYY-MM-DD HH:mm"
					noHeader
					overlay
					buttonNowTranslation="Ahora"
					@input="mantenimientos_update_page_action(1)"
				/>
			</v-col>
		</v-row>
		<v-dialog v-model="dialogDesglose" max-width="70%" persistent>
			<v-card>
				<v-card-title> Detalles del Mantenimiento </v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" md="12" sm="12">
							<div class="text-subtitle-1">Costos de Facturas</div>
							<v-data-table
								:items="facturaCostos"
								:headers="headerDesgloseFacturasFiltrados"
								:loading="loadingDesglose"
								loading-text="Cargando... Espere, Por Favor."
                hide-default-footer
								:items-per-page="-1"
                :footer-props="{
									disableItemsPerPage: true,
									disablePagination: true,
								}"
								:disable-sort="true"
							>
								<template v-slot:item.total="{ item }">
									$ {{ item.total.toFixed(2) }}
								</template>
                <template v-slot:item.porcentaje="{ item }">
									{{ item.porcentaje.toFixed(2) }} %
								</template>
                <template
									v-slot:item.costoProporcional="{ item }"
								>
									$ {{ item.costoProporcional.toFixed(2) }}
								</template>
							</v-data-table>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="12" sm="12">
							<div class="text-subtitle-1">Costos de Salidas de Inventario</div>
							<v-data-table
								:items="movimientoCostos"
								:headers="headerDesgloseMovimientosFiltrados"
								:loading="loadingDesglose"
								loading-text="Cargando... Espere, Por Favor."
                hide-default-footer
								:items-per-page="-1"
                :footer-props="{
									disableItemsPerPage: true,
									disablePagination: true,
								}"
								:disable-sort="true"
							>
								<template v-slot:item.articulo="{ item }">
									[{{item.articuloCodigo}}] - {{ item.articulo }}
								</template>
								<template v-slot:item.cantidad="{ item }">
									{{ item.cantidadProporcional.toFixed(2) }} {{item.unidad}}
								</template>
								<template v-slot:item.costo="{ item }">
									$ {{ item.costoProporcional.toFixed(2) }}
								</template>
							</v-data-table>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="12" sm="12">
							<div class="text-subtitle-1">Comprobaciones</div>
							<v-data-table
								:items="comprobaciones"
								:headers="headerComprobaciones"
								:loading="loadingDesglose"
								loading-text="Cargando... Espere, Por Favor."
                				hide-default-footer
								:items-per-page="-1"
                				:footer-props="{
									disableItemsPerPage: true,
									disablePagination: true,
								}"
								:disable-sort="true"
							>
								<template v-slot:item.satisfactoria="{ item }">
									<v-btn-toggle
										v-model="item.satisfactoria"
										class="my-3"
									>
										<v-btn
											depressed
											small
											class="ma-0"
											style="pointer-events: none"
											:color="
												item.satisfactoria
													? 'success'
													: 'grey lighten-1'
											"
											>Si</v-btn
										>
										<v-btn
											depressed
											small
											class="ma-0"
											style="pointer-events: none"
											:color="
												!item.satisfactoria
													? 'error'
													: 'grey lighten-1'
											"
											>No</v-btn
										>
									</v-btn-toggle>
								</template>
								<template v-slot:item.comentario="{ item }">
									<p class="mb-0">{{item.comentario == null ? 'N/A' : item.comentario }}</p>
								</template>
								<template v-slot:item.documentos="{ item }">
									<p 
										v-if="
											item.documentos == null || 
											item.documentos.length == 0
										"
										class="mb-0"
									>
										N/A
									</p>
									<template
										v-for="(
											documento, idx
										) in item.documentos"
									>
										<div
											class="
												d-inline-block
												mx-2
												py-2
											"
											:key="'links-' + idx"
											style="font-size: 14px"
										>
											<a 
												:href="`/api/Documentos/Descargar/${documento}?access_token=${token}`" 
												class="text-decoration-none"
												target="_blank"
												>{{ documento }}</a
											>
										</div>
									</template>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="12" sm="12">
							<div class="text-subtitle-1">Recomendaciones</div>
							<v-textarea
								filled
                                auto-grow
                                rows="1"
                                hide-details
								readonly
								:value="
									(recomendacion == null ||
									recomendacion == undefined ||
									recomendacion == '')
									? 'N/A'
									: recomendacion
								"
							></v-textarea>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						color="red"
						@click="cerrarDesglose"
					>
						Cerrar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<br />
		<download-btn
			v-if="!seleccionable" 
			color="blue darken-1" 
			text 
			@click="descargarReporte"
			label="Descargar Reporte<br>de Mantenimientos Realizados"
		></download-btn>
		<v-data-table
			v-if="!seleccionable"
			:headers="headersFiltrados"
			:items="mantenimientos"
			:loading="loading"
			loading-text="Cargando... Espere, Por Favor."
			:server-items-length="mantenimientos_total"
			:items-per-page="mantenimientos_items_per_page"
			:page="mantenimientos_actual_page"
			@update:page="mantenimientos_update_page_action"
			@update:items-per-page="
				(ipp) => (mantenimientos_items_per_page = ipp)
			"
			@update:sort-by="mantenimientos_sort_by_action"
			:footer-props="{
				disableItemsPerPage: true,
				disablePagination: this.loading,
			}"
			:disable-sort="true"
		>
			<template v-slot:item.mecanicos="{ item }">
				<ul>
					<li
						v-for="(mecanico, idx) in item.mecanicos"
						:key="'mec-' + idx"
					>
						{{ mecanico.nombre }} - ${{mecanico.costo.toFixed(2)}}
					</li>
				</ul>
			</template>
			<template v-slot:item.costoTotal="{ item }">
				$ {{item.costoTotal.toFixed(2)}}
			</template>
			<template v-slot:item.actions="{ item }">
				<v-tooltip
					
					bottom
					color="black"
					class="white--text"
				>
					<template v-slot:activator="{ on }">
						<v-icon v-on="on" small @click="verDesglose(item)">
							mdi-eye
						</v-icon>
					</template>
					<span class="white--text">Ver Detalles</span>
				</v-tooltip>
			</template>
		</v-data-table>
		<v-data-table
			v-model="seleccionados"
			v-if="seleccionable"
			show-select
			:single-select="false"
			item-key="idMantenimientoTarea"
			:headers="headersSeleccion"
			:items="mantenimientos"
			:loading="loading"
			loading-text="Cargando... Espere, Por Favor."
			:server-items-length="mantenimientos_total"
			:items-per-page="mantenimientos_items_per_page"
			:page="mantenimientos_actual_page"
			@update:page="mantenimientos_update_page_action"
			@update:items-per-page="
				(ipp) => (mantenimientos_items_per_page = ipp)
			"
			@update:sort-by="mantenimientos_sort_by_action"
			:footer-props="{
				disableItemsPerPage: true,
				disablePagination: this.loading,
			}"
			:disable-sort="true"
		>
			<template v-slot:item.mecanicos="{ item }">
				<ul>
					<li
						v-for="(mecanico, idx) in item.mecanicos"
						:key="'mec-' + idx"
					>
						{{ mecanico.nombre }}
					</li>
				</ul>
			</template>
		</v-data-table>
	</v-col>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
import DownloadBtn from '../../DownloadBtn.vue';

export default {
	components: { DownloadBtn },
	props: {
		seleccionable: {
			type: Boolean,
			default: false,
		},
		paros:{
			type: Boolean,
			default: false,
		}
	},
	data: () => ({
		comprobaciones: [],
		headerComprobaciones: [
			{
				text: "Comprobación",
				align: "center",
				sort: false,
				value: "comprobacion",
				width: "25%"
			},
			{
				text: "Satisfactoria",
				align: "center",
				sort: false,
				value: "satisfactoria",
				width: "20%"
			},
			{
				text: "Comentario",
				align: "center",
				sort: false,
				value: "comentario",
				width: "25%"
			},
			{
				text: "Evidencias",
				align: "center",
				sort: false,
				value: "documentos",
				width: "30%"
			},
		],
    dialogDesglose: false,
		loadingDesglose: false,
		recomendacion: "",
		facturaCostos: [],
		movimientoCostos:[],
		seleccionados: [],
		seleccionadosF: [],
		filtros: {
			tipo: null,
			codigosNombres: null,
			categoria: null,
			maquina: null,
			instancia: null,
			responsable: null,
			mecanicos: [],
			inicio: null,
			fin: null,
		},
		tipos: [
			{
				idTipo: 1,
				nombre: "Preventivo",
			},
			{
				idTipo: 2,
				nombre: "Correctivo",
			},
		],
		codigosNombres: [],
		codigos: [],
		nombresM: [],
		categorias: [],
		maquinas: [],
		instancias: [],
		mantenimientos: [],
		personas: [],
		loading: false,
		mantenimientos_total: 0,
		mantenimientos_items_per_page: 10,
		mantenimientos_actual_page: 1,
		headers: [
			{
				text: "Tipo",
				align: "center",
				sort: false,
				value: "mantenimientoTipo",
				width: "8.33%",
			},
			{
				text: "Código",
				align: "center",
				sort: false,
				value: "mantenimientoCodigo",
				width: "8.33%",
			},
			{
				text: "Nombre",
				align: "center",
				sort: false,
				value: "mantenimiento",
				width: "8.33%",
			},
			{
				text: "Inicio",
				align: "center",
				sort: false,
				value: "inicioRealizo",
				width: "8.33%",
			},
			{
				text: "Termino",
				align: "center",
				sort: false,
				value: "finRealizo",
				width: "8.33%",
			},
			{
				text: "Máquina",
				align: "center",
				sort: false,
				value: "maquina",
				width: "15%",
			},
			{
				text: "Máquina Instancia",
				align: "center",
				sort: false,
				value: "maquinaIns",
				width: "8.33%",
			},
			{
				text: "Responsable",
				align: "left",
				sort: false,
				value: "responsable",
				width: "11%",
			},
			{
				text: "Realizado Por",
				align: "left",
				sort: false,
				value: "mecanicos",
				width: "11%",
			},
			{
				text: "Costo Total",
				align: "center",
				sort: false,
				value: "costoTotal",
				width: "12%",
			},
			{
				text: "Acciones",
				align: "center",
				sort: false,
				value: "actions",
			},
		],
    headersSeleccion: [
			{
				text: "Tipo",
				align: "center",
				sort: false,
				value: "mantenimientoTipo",
				width: "8.33%",
			},
			{
				text: "Código",
				align: "center",
				sort: false,
				value: "mantenimientoCodigo",
				width: "8.33%",
			},
			{
				text: "Nombre",
				align: "center",
				sort: false,
				value: "mantenimiento",
				width: "8.33%",
			},
			{
				text: "Inicio",
				align: "center",
				sort: false,
				value: "inicioRealizo",
				width: "8.33%",
			},
			{
				text: "Termino",
				align: "center",
				sort: false,
				value: "finRealizo",
				width: "8.33%",
			},
			{
				text: "Máquina",
				align: "center",
				sort: false,
				value: "maquina",
				width: "15%",
			},
			{
				text: "Máquina Instancia",
				align: "center",
				sort: false,
				value: "maquinaIns",
				width: "8.33%",
			},
			{
				text: "Responsable",
				align: "left",
				sort: false,
				value: "responsable",
				width: "17%",
			},
			{
				text: "Realizado Por",
				align: "left",
				sort: false,
				value: "mecanicos",
				width: "17%",
			},
		],
		headerDesgloseFacturas: [
			{
				text: "Proveedor",
				align: "left",
				sort: false,
				value: "proveedor",
				width: "40%"
			},
      {
				text: "Costo Total Factura",
				align: "center",
				sort: false,
				value: "total",
				width: "20%"
			},
      {
				text: "Porcentaje Asignado",
				align: "center",
				sort: false,
				value: "porcentaje",
				width: "20%"
			},
			{
				text: "Costo",
				align: "center",
				sort: false,
				value: "costoProporcional",
				width: "20%"
			},
		],
		headerDesgloseMovimientos: [
			{
				text: "Artículo",
				align: "left",
				sort: false,
				value: "articulo",
				width: "50%"
			},
      {
				text: "Cantidad",
				align: "center",
				sort: false,
				value: "cantidad",
				width: "30%"
			},
      {
				text: "Costo",
				align: "center",
				sort: false,
				value: "costo",
				width: "20%"
			},
		],
	}),
	computed: {
		headerDesgloseMovimientosFiltrados(){
			return this.permisoVista('mantenimiento-historial','$')
				? this.headerDesgloseMovimientos
				: this.headerDesgloseMovimientos.filter(head=>head.value!='costo')
		},
		headerDesgloseFacturasFiltrados(){
			return this.permisoVista('mantenimiento-historial','$')
				? this.headerDesgloseFacturas
				: this.headerDesgloseFacturas.filter(head=>head.value!='total'&&head.value!='costoProporcional')
		},
		headersFiltrados(){
			return this.permisoVista('mantenimiento-historial','$')
				? this.headers
				: this.headers.filter(head=>head.value!='costoTotal')
		},
		computedCodNom() {
			if (this.filtros.tipo === 1)
				return this.codigosNombres.filter(
					(codnom) =>
						codnom.idMantenimientoPreventivo !== null && codnom
				);
			else if (this.filtros.tipo === 2)
				return this.codigosNombres.filter(
					(codnom) =>
						codnom.idMantenimientoCorrectivo !== null && codnom
				);
			else return this.codigosNombres;
		},
		mantenimientos_filtros() {
			var url = "";
			if (this.$utils.isValid(this.filtros.codigosNombres)) {
				const idCorrectivos = this.filtros.codigosNombres.map(
					(item) => {
						if (item.idMantenimientoCorrectivo !== null)
							return item.idMantenimientoCorrectivo;
					}
				);
				const idPreventivos = this.filtros.codigosNombres.map(
					(item) => {
						if (item.idMantenimientoPreventivo !== null)
							return item.idMantenimientoPreventivo;
					}
				);
				if (
					idCorrectivos !== null &&
					idCorrectivos.length > 0 &&
					!idCorrectivos.includes(undefined)
				)
					idCorrectivos.forEach((element) => {
						url += "&IdsMantenimientosCorrectivos=" + element;
					});
				if (
					idPreventivos !== null &&
					idPreventivos.length > 0 &&
					!idPreventivos.includes(undefined)
				)
					idPreventivos.forEach((element) => {
						url += "&IdsMantenimientosPreventivos=" + element;
					});
			}

			if (this.$utils.isValid(this.filtros.tipo)) {
				url += "&TipoMantenimiento=" + this.filtros.tipo;
			}

			if (this.$utils.isValid(this.filtros.categoria)) {
				url += "&IdMaquinaCategoria=" + this.filtros.categoria;
			}

			if (this.$utils.isValid(this.filtros.maquina)) {
				url += "&idMaquina=" + this.filtros.maquina;
			}

			if (this.$utils.isValid(this.filtros.instancia)) {
				url += "&idMaquinaIns=" + this.filtros.instancia;
			}

			if (this.$utils.isValid(this.filtros.responsable)) {
				url += "&idResponsable=" + this.filtros.responsable;
			}

			if (
				this.$utils.isValid(this.filtros.mecanicos) &&
				this.filtros.mecanicos.length > 0
			) {
				this.filtros.mecanicos.forEach(
					(x) => (url += `&idsMecanicos=${x || 0}`)
				);
			}

			if (this.$utils.isValid(this.filtros.inicio)) {
				url += "&inicio=" + this.filtros.inicio;
			}

			if (this.$utils.isValid(this.filtros.fin)) {
				url += "&fin=" + this.filtros.fin;
			}

			return url;
		},
		mantenimientos_fetch_url() {
			let url = `/Mantenimientos/MantenimientosRealizados?Paginar=true&page=${this.mantenimientos_actual_page}&size=${this.mantenimientos_items_per_page}`;
			if(this.paros) url += "&filtrarUsadoParos=true";
			return url + this.mantenimientos_filtros;
		},
		maquinasFiltradas() {
			if (this.$utils.isValid(this.filtros.categoria)) {
				if (this.filtros.categoria == 0) {
					return this.instancias.filter((instancia) => {
						return instancia.idMaquinaCategoria == null;
					});
				} else {
					return this.instancias.filter((instancia) => {
						return (
							instancia.idMaquinaCategoria ==
							this.filtros.categoria
						);
					});
				}
			} else return this.instancias;
		},
		...mapState(["token"])
	},
	mounted() {
		this.initialize();
	},
	methods: {
		lblcodNom: (item) => `[${item.codigo}] - ${item.nombre}`,
		codNombres: (elemento) => elemento,
		marcaModelo: (item) => item.marca + " - " + item.modelo,
		nombrePersona: (persona) =>
			persona.nombre + " " + persona.paterno + " " + persona.materno,
    cerrarDesglose(){
      this.dialogDesglose = false;
      this.facturaCostos = [];
			this.movimientoCostos = [];
			this.comprobaciones = [];
			this.recomendacion = "";
    },
		verDesglose(item) {
      this.loadingDesglose = true;
      this.dialogDesglose = true;
			this.facturaCostos = item.facturaCostos;
			this.movimientoCostos = item.movimientoCostos;
			this.comprobaciones = item.comprobaciones;
			this.recomendacion = item.recomendacion;
      this.loadingDesglose = false;
		},
		clickSeleccionados() {
			this.seleccionadosF = this.seleccionados;
			return Object.assign([], this.seleccionadosF);
		},
		resetSeleccionados() {
			this.seleccionados = this.seleccionadosF;
		},
		fullresetSeleccionados() {
			this.seleccionados = [];
		},
		initialize() {
			this.mantenimientos_update_page_action(1);
			this.getMaquinas();
			this.getInstancias();
			this.getPersonas();
			this.getCodigosNombres();
		},
		changeCategoria() {
			this.filtros.maquina = null;
			this.filtros.instancia = null;
			this.mantenimientos_update_page_action(1);
		},
		changeMaquina() {
			this.filtros.instancia = null;
			this.mantenimientos_update_page_action(1);
		},
		getCodigosNombres() {
			axios
				.get("/Mantenimientos/GetMantenimientosPreventivosCorrectivos")
				.then((response) => {
					this.codigosNombres = response.data;
				})
				.catch((error) => console.log(error));
		},
		getMaquinas() {
			axios
				.get("/Maquinas")
				.then((response) => {
					this.maquinas = response.data.filter(function (el) {
						return el.esMaquina == true;
					});
					this.categorias = this.maquinas.map((elemento) => ({
						idMaquinaCategoria:
							elemento.idMaquinaCategoria == null
								? 0
								: elemento.idMaquinaCategoria,
						categoria: elemento.categoria,
					}));
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getInstancias() {
			axios
				.get("/MaquinaInstancias")
				.then((response) => {
					this.instancias = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getPersonas() {
			axios
				.get("/Personas/Operadores")
				.then((response) => {
					this.personas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		mantenimientos_sort_by_action($sort) {},
		async mantenimientos_update_page_action(page) {
			this.mantenimientos_actual_page = page;
			this.loading = true;
			try {
				let response = await this.getMantenimientos();
				this.mantenimientos = response.data.result;
				this.mantenimientos_total = response.data.total;
				this.loading = false;
			} catch (exception) {
				console.log(exception);
			}
		},
		getMantenimientos() {
			//* Realizamos peticion HTTP
			return new Promise((resolve, reject) => {
				axios
					.get(this.mantenimientos_fetch_url)
					.then((response) => resolve(response))
					.catch((error) => reject(error));
			});
		},
		instanciasFiltradas() {
			if (this.$utils.isValid(this.filtros.maquina)) {
				return this.instancias.filter((instancia) => {
					return instancia.idMaquina == this.filtros.maquina;
				});
			} else return this.instancias;
		},
		descargarReporte() {
			var datetime = moment().format("YYYYMMDDHHmmss");
			var url = this.mantenimientos_filtros;
			if (url.length > 0 && url[0] == "&") url = "?" + url.substring(1);
			this.$utils.axios.downloadFile(
				"/Mantenimientos/ReporteXLSXMantenimientosRealizados" + url,
				"GET",
				"historial-mantenimientos-" + datetime + ".xlsx",
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
			);
		},
	},
};
</script>